import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getTradeMarkets, saveBatchTradeMarkets } from '../../api/tradeMarkets';
import type { TradeMarket } from '../../types/TradeMarket';
import { t } from '../../i18n/t';

const columnDefs: ColDef<TradeMarket>[] = [
  {
    field: 'tradeMarketId',
    headerName: t('tradeMarkets.columns.tradeMarketId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<TradeMarket>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'tradeMarketName',
    headerName: t('tradeMarkets.columns.tradeMarketName'),
    flex: 1,
    editable: true,
  },
];

const newRowDefaults = (): Partial<TradeMarket> => ({
  tradeMarketId: 0,
  tradeMarketName: '',
});

export function TradeMarketsPage() {
  return (
    <LopCrudPage<TradeMarket>
      resourceCode="tradeMarkets"
      titleKey="tradeMarkets.pageTitle"
      idField="tradeMarketId"
      getRows={getTradeMarkets}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchTradeMarkets(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
